import { motion } from "framer-motion";
import { Car, Phone } from "lucide-react";

/**
 * Hero Section Component
 *
 * Features:
 * - Full-screen video background
 * - Animated navigation bar that changes on scroll
 * - Mobile-responsive menu
 * - Call-to-action buttons
 */
export default function Hero() {
  // useEffect(() => {
  //   const onDown = (e: MouseEvent) => {
  //     const el = navRef.current;
  //     if (!el) return;

  //     const target = e.target;
  //     if (target instanceof Node && !el.contains(target)) {
  //       setOpenDropdown(null);
  //     }
  //   };

  //   const onKey = (e: KeyboardEvent) => {
  //     if (e.key === "Escape") setOpenDropdown(null);
  //   };

  //   document.addEventListener("mousedown", onDown);
  //   document.addEventListener("keydown", onKey);

  //   return () => {
  //     document.removeEventListener("mousedown", onDown);
  //     document.removeEventListener("keydown", onKey);
  //   };
  // }, []);

  // useEffect(() => {
  //   const handleScroll = () => {
  //     setIsScrolled(window.scrollY > 100);
  //   };
  //   window.addEventListener("scroll", handleScroll, { passive: true });
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, []);

  return (
    <section id="home" className="relative h-screen w-full overflow-hidden">
      {/* Video Background */}
      <div className="absolute inset-0 z-0">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover"
          poster="/images/dealership-exterior.jpg"
        >
          <source src="/images/hero_video.webm" type="video/webm" />
        </video>
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-black/30" />
      </div>

      {/* Hero Content */}
      <div className="relative z-10 h-full flex items-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="max-w-2xl pl-2 sm:pl-3 lg:pl-4 pt-12 sm:pt-14 lg:pt-16">
            {/* <motion.p
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5, duration: 0.6 }}
              className="text-brand-gold text-sm font-semibold tracking-[0.3em] uppercase mb-4"
            >
              Welcome to Big Boys Motor Club
            </motion.p> */}

            <motion.h1
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.7, duration: 0.8 }}
              className="font-serif text-5xl sm:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6"
            >
              WELCOME TO
              <br />
              <span className="text-brand-red">BIG BOYS MOTORCLUB</span>
              <br />
              YOUR PREOWNED
              <br />
              PARTNER
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.9, duration: 0.6 }}
              className="text-white/80 text-lg mb-8 max-w-lg"
            >
              Explore curated inventory, premium detailing, and a cinematic
              buying journey — built for those who love cars.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 1.1, duration: 0.6 }}
              className="flex flex-wrap gap-4"
            >
              <a
                href="#inventory"
                className="inline-flex items-center gap-2 px-8 py-4 bg-brand-red text-white rounded-full font-semibold hover:bg-red-700 transition-all duration-300 hover:-translate-y-1 hover:shadow-glow-red"
              >
                <Car className="w-5 h-5" />
                Explore Inventory
              </a>
              <a
                href="tel:+16043588081"
                className="inline-flex items-center gap-2 px-8 py-4 bg-white/10 text-white border-2 border-white/30 rounded-full font-semibold hover:bg-white/20 transition-all duration-300 hover:-translate-y-1"
              >
                <Phone className="w-5 h-5" />
                Contact Us
              </a>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10"
      >
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ repeat: Infinity, duration: 2 }}
          className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center pt-2"
        >
          <div className="w-1.5 h-3 bg-white/80 rounded-full" />
        </motion.div>
      </motion.div>
    </section>
  );
}
